"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBurnTxClaimable = exports.isBurnTxCheckpointed = exports.isBlockCheckpointed = exports.isBurnTxProcessed = void 0;
var bignumber_1 = require("@ethersproject/bignumber");
var solidity_1 = require("@ethersproject/solidity");
var bytes_1 = require("@ethersproject/bytes");
var receiptProof_1 = require("./proofs/receiptProof");
var blocks_1 = require("./utils/blocks");
var logIndex_1 = require("./utils/logIndex");
var contracts_1 = require("./utils/contracts");
var buffer_1 = require("./utils/buffer");
var calculateExitHash = function (maticChainProvider, burnTxHash, logEventSigOrIndex) { return __awaiter(void 0, void 0, void 0, function () {
    var burnTxReceipt, burnTxBlock, receipts, path, nibbleArray, nibblesHex, logIndex, exitHash;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, maticChainProvider.getTransactionReceipt(burnTxHash)];
            case 1:
                burnTxReceipt = _a.sent();
                if (typeof burnTxReceipt.blockNumber === "undefined") {
                    throw new Error("Could not find find blocknumber of burn transaction");
                }
                return [4 /*yield*/, blocks_1.getFullBlockByHash(maticChainProvider, burnTxReceipt.blockHash)];
            case 2:
                burnTxBlock = _a.sent();
                return [4 /*yield*/, Promise.all(burnTxBlock.transactions.map(function (tx) { return maticChainProvider.getTransactionReceipt(tx); }))];
            case 3:
                receipts = _a.sent();
                return [4 /*yield*/, receiptProof_1.buildMerklePatriciaProof(burnTxReceipt, receipts, burnTxBlock.number, burnTxBlock.hash)];
            case 4:
                path = (_a.sent()).path;
                nibbleArray = [];
                // RootChain.sol drops first byte (2 nibbles) from nibble array when calculating nibbleArray
                buffer_1.hexToBuffer(path)
                    .slice(1)
                    .forEach(function (byte) {
                    nibbleArray.push("0x0" + Math.floor(byte / 0x10).toString(16));
                    nibbleArray.push("0x0" + (byte % 0x10).toString(16));
                });
                nibblesHex = bytes_1.hexConcat(nibbleArray);
                logIndex = typeof logEventSigOrIndex === "string" ? logIndex_1.getLogIndex(burnTxReceipt, logEventSigOrIndex) : logEventSigOrIndex;
                exitHash = solidity_1.keccak256(["uint256", "bytes", "uint256"], [burnTxReceipt.blockNumber, nibblesHex, logIndex]);
                return [2 /*return*/, exitHash];
        }
    });
}); };
exports.isBurnTxProcessed = function (rootChainProvider, maticChainProvider, rootChainContractAddress, burnTxHash, logEventSig) { return __awaiter(void 0, void 0, void 0, function () {
    var exitHash, rootChainContract;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, calculateExitHash(maticChainProvider, burnTxHash, logEventSig)];
            case 1:
                exitHash = _a.sent();
                rootChainContract = contracts_1.getRootChainManager(rootChainProvider, rootChainContractAddress);
                return [2 /*return*/, rootChainContract.processedExits(exitHash)];
        }
    });
}); };
exports.isBlockCheckpointed = function (rootChainProvider, rootChainContractAddress, blockNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var checkpointManagerContract, lastChildBlock;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, contracts_1.getCheckpointManager(rootChainProvider, rootChainContractAddress)];
            case 1:
                checkpointManagerContract = _a.sent();
                return [4 /*yield*/, checkpointManagerContract.getLastChildBlock()];
            case 2:
                lastChildBlock = _a.sent();
                return [2 /*return*/, bignumber_1.BigNumber.from(lastChildBlock).gte(blockNumber)];
        }
    });
}); };
exports.isBurnTxCheckpointed = function (rootChainProvider, maticChainProvider, rootChainContractAddress, burnTxHash) { return __awaiter(void 0, void 0, void 0, function () {
    var burnTx;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, maticChainProvider.getTransaction(burnTxHash)];
            case 1:
                burnTx = _a.sent();
                if (typeof burnTx === null) {
                    throw new Error("Could not find transaction corresponding to burnTxHash");
                }
                else if (typeof burnTx.blockNumber === "undefined") {
                    throw new Error("Could not find blocknumber of burnTx");
                }
                return [2 /*return*/, exports.isBlockCheckpointed(rootChainProvider, rootChainContractAddress, burnTx.blockNumber)];
        }
    });
}); };
exports.isBurnTxClaimable = function (rootChainProvider, maticChainProvider, rootChainContractAddress, burnTxHash, logEventSig) { return __awaiter(void 0, void 0, void 0, function () {
    var checkpointed, alreadyClaimed;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, exports.isBurnTxCheckpointed(rootChainProvider, maticChainProvider, rootChainContractAddress, burnTxHash)];
            case 1:
                checkpointed = _a.sent();
                return [4 /*yield*/, exports.isBurnTxProcessed(rootChainProvider, maticChainProvider, rootChainContractAddress, burnTxHash, logEventSig)];
            case 2:
                alreadyClaimed = _a.sent();
                // Withdrawal can be claimed if it is checkpointed and hasn't already been claimed
                return [2 /*return*/, checkpointed && !alreadyClaimed];
        }
    });
}); };
